import { useSelector, useDispatch } from 'react-redux';
import { deleteQuery, updateQuery } from '../../store/knownDataSlice';
import RouteMap from '../../components/RouteMap';
import { displayDistance, displayPrice, displayRouteStops, formatDuration } from '../../tables/common';
import { toast } from 'react-toastify';
import { unwrapResult } from '@reduxjs/toolkit';
import { useNavigate } from 'react-router-dom';
import { fetch } from '../../store/knownDataSlice';
import { useState } from 'react';
import { timeConverter } from '../../util';




function EditQuery({ id }) {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);

    const [ start, setStart ] = useState(timeConverter(data["query_start"]));
    const [ passengers, setPassengers ] = useState(data["query_passengers"]);
    const [ fullname, setFullname ] = useState(data["query_fullname"]);
    const [ promo, setPromo ] = useState(data["query_promo"]);
    const [ email, setEmail ] = useState(data["query_email"]);
    const [ phone, setPhone ] = useState(data["query_phone"]);
    const [ company, setCompany ] = useState(data["query_company"]);

    console.log("typeof passengers:", typeof passengers);

    async function onSave() {
        // Notes are edited in AllNotes, not here. Always send the latest stored value so
        // saving this form never overwrites notes that were saved elsewhere on the page.
        const notes = data["query_notes"];
        const res = await unwrapResult(await dispatch(updateQuery({id, start: new Date(start).getTime() / 1000, passengers, notes, fullname, promo, email, phone, company})));
        if(!res) {
            setStart(timeConverter(data["query_start"]));
            setPassengers(data["query_passengers"]);
            setFullname(data["query_fullname"]);
            setPromo(data["query_promo"]);
            setEmail(data["query_email"]);
            setPhone(data["query_phone"]);
            setCompany(data["query_company"]);

            return;
        }

        dispatch(fetch({ id }));

        toast.success("Muudatused salvestatud!");
    }

    return (
        <div className="column g32" style={{ width: '100%' }}>

            <hr />

            <h2>Muutmine</h2>

            <div className="column center-cross">

                <div className="line g16" style={{ width: 800, maxWidth: '100%', justifyContent: 'space-between' }}>

                    <div className="column g8 grow">
                        <b>Start</b>
                        <input type='datetime-local' value={start} onChange={e => setStart(e.target.value)} />
                    </div>

                    <div className="column g8 grow">
                        <b>Reisijaid</b>
                        <input type='number' value={passengers} onChange={e => setPassengers(+e.target.value)} />
                    </div>

                    <div className="column g8 grow">
                        <b>Täisnimi</b>
                        <input type='text' value={fullname} onChange={e => setFullname(e.target.value)} />
                    </div>

                    <div className="column g8 grow">
                        <b>E-mail</b>
                        <input type='text' value={email} onChange={e => setEmail(e.target.value)} />
                    </div>

                    <div className="column g8 grow">
                        <b>Telefon</b>
                        <input type='text' value={phone} onChange={e => setPhone(e.target.value)} />
                    </div>

                    <div className="column g8 grow">
                        <b>Firma</b>
                        <input type='text' value={company} onChange={e => setCompany(e.target.value)} />
                    </div>

                </div>

            </div>

            <p style={{ color: '#888', textAlign: 'center', width: '100%' }}>NB! Kontrolli ega kuupäeval pole päev ja kuu vahetusse läinud!</p>

            <div className="row" style={{ justifyContent: 'flex-end' }}>
                <button onClick={onSave}>Salvesta</button>
            </div>
        </div>
    )
};

export default EditQuery;